import { getStorage, ref, getDownloadURL, uploadString } from 'firebase/storage';
import React, { useState, useEffect } from 'react';
import { makeStyles } from '@mui/styles';
import { Box, Container, Typography, Button, Divider } from '@mui/material';
import Organization from './components/Organization';
import { useFirebase, useFirestore } from 'react-redux-firebase';
import collections from '../../constants/FirestoreCollections';
import { toUpper, orderBy } from 'lodash';
import { actions } from '../../actions';
import { useDispatch, useSelector } from 'react-redux';
import { Pause, PlayArrow } from '@mui/icons-material';
import axios from 'axios';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
const MySwal = withReactContent(Swal);

const useStyles = makeStyles((theme) => ({
  appBarSpacer: theme.mixins.toolbar,
  organizationItem: {
    height: '80px',
    overflow: 'hidden',
  },
  itemTitle: {
    fontSize: '20px',
  },
  openItem: {
    height: 'auto',
  },
  sectionTitle: {
    fontSize: '24px',
    fontWeight: 300,
  },
  actionsTitle: {
    fontSize: theme.sizes.sm.t1,
    fontWeight: 'bold',
    marginBottom: 4,
  },
  startService: {
    backgroundColor: theme.palette.randomColor4.main,
    color: theme.palette.white.main,
    '&:hover': {
      backgroundColor: theme.palette.randomColor4.light,
    },
  },
  stopService: {
    backgroundColor: theme.palette.randomColor1.main,
    color: theme.palette.white.main,
    '&:hover': {
      backgroundColor: theme.palette.randomColor1.light,
    },
  },
}));

export default function Organizations() {
  const classes = useStyles();
  const firestore = useFirestore();
  const appDispatch = useDispatch();
  const firebase = useFirebase();
  let [organizations, setOrganizations] = useState([]);
  const [credentials, setCredentials] = useState({});
  const [actualItem, setActualItem] = useState({});
  const [create, setCreate] = useState(false);
  const [config, setConfig] = useState();
  const organization = useSelector((state) => state.app.organization);
  const projectId = process.env.REACT_APP_PROJECT_ID;
  organizations = orderBy(organizations, ['name'], ['asc']);

  useEffect(() => {
    firestore
      .collection(collections.configurations)
      .where('name', '==', 'prestobots')
      .get()
      .then((res) => {
        if (!res.empty) {
          setConfig({ id: res.docs[0].id, ...res.docs[0].data() });
        }
      });
    firestore
      .collection(collections.organizations)
      .get()
      .then((res) => {
        const tmpOrganizations = [];
        res.forEach((e) => {
          tmpOrganizations.push({ ...e.data(), id: e.id });
        });
        setOrganizations(tmpOrganizations);
      });
  }, [firestore]);

  const handleShow = (item) => {
    if (actualItem.item !== item || (actualItem.item === item && actualItem.edit))
      setActualItem({ item, show: true });
    else setActualItem({});
  };
  const handleEdit = (item) => {
    if (actualItem.item !== item || (actualItem.item === item && actualItem.show))
      setActualItem({ item, edit: true });
    else setActualItem({});
  };
  const handleSubmit = (id, mode, newItem) => {
    if (mode === 'create') {
      setOrganizations([...organizations, newItem]);
      setCreate(false);
    } else {
      setOrganizations(organizations.map((e) => (e.id === id ? { ...e, ...newItem } : e)));
    }
  };

  const handleChangeStatusService = async (local) => {
    appDispatch({
      type: actions.changeLoading,
      loading: { loading: true, priority: 1 },
    });
    if (local) {
      firestore
        .collection(collections.organizations)
        .doc(organization.id)
        .update({ stoppedNotificationsService: !organization.stoppedNotificationsService })
        .then(() => {
          if (organization.stoppedNotificationsService) {
            firebase
              .auth()
              .currentUser.getIdToken(true)
              .then(function (token) {
                axios(
                  `https://us-central1-${projectId}.cloudfunctions.net/sendPendingNotifications`,
                  {
                    method: 'get',
                    headers: {
                      Authorization: `bearer ${token}`,
                    },
                  },
                ).then(() => {});
              });
          }
        })
        .finally(() => {
          appDispatch({
            type: actions.changeLoading,
            loading: { loading: false, priority: 1 },
          });
          appDispatch({
            type: actions.alert,
            alert: {
              snackbarOpen: true,
              snackbarMessage: `Se ${
                !organization.stoppedNotificationsService ? 'FRENO' : 'REANUDO'
              } correctamente el servicio de recordatorios para ${
                organization.displayName || organization.name
              }`,
              snackbarSeverity: 'success',
            },
          });
        });
    } else {
      if (config) {
        firestore
          .collection(collections.configurations)
          .doc(config.id)
          .update({ stoppedNotificationsService: !config.stoppedNotificationsService })
          .then(() => {
            if (config.stoppedNotificationsService) {
              const sendPendingNotifications = firebase
                .functions()
                .httpsCallable('sendPendingNotifications');
              sendPendingNotifications();
            }
          })
          .finally(() => {
            setConfig({
              ...config,
              stoppedNotificationsService: !config.stoppedNotificationsService,
            });
            appDispatch({
              type: actions.changeLoading,
              loading: { loading: false, priority: 1 },
            });
            appDispatch({
              type: actions.alert,
              alert: {
                snackbarOpen: true,
                snackbarMessage: `Se ${
                  !config.stoppedNotificationsService ? 'FRENO' : 'REANUDO'
                } correctamente el servicio de recordatorios para todos los clientes`,
                snackbarSeverity: 'success',
              },
            });
          });
      }
    }
  };

  useEffect(() => {
    const storage = getStorage();
    const agentsRef = ref(storage, 'keys/agents keys/agents.json');
    getDownloadURL(agentsRef).then((url) => {
      axios(url).then((res) => {
        setCredentials(res.data);
      });
    });
  }, [firebase]);

  const generateCredentials = (id) => {
    MySwal.fire({
      text: '¿Esta seguro que desea generar credenciales nuevas?',
      showDenyButton: true,
      showConfirmButton: true,
      denyButtonText: 'Cancelar',
      confirmButtonText: 'Aceptar',
      icon: 'info',
    }).then(async (result) => {
      if (result.isConfirmed) {
        const random =
          Math.random().toString(36).slice(2) +
          Math.random().toString(36).slice(2) +
          Math.random().toString(36).slice(2);
        const newData = { ...credentials, [id]: random.slice(0, 20) };
        const storage = getStorage();
        const agentsRef = ref(storage, 'keys/agents keys/agents.json');
        uploadString(agentsRef, JSON.stringify(newData)).then((res) => {
          MySwal.fire({
            text: `Credenciales generadas exitosamente\nUsuario: ${id}\nContraseña: ${random.slice(
              0,
              20,
            )}`,
            icon: 'info',
          });
        });
      }
    });
  };

  return (
    <div>
      <div className={classes.appBarSpacer} />
      <Box p={4}>
        <Container className={classes.messages} maxWidth="lg">
          <Typography className={classes.actionsTitle}>ACCIONES</Typography>
          <Box my={2} display="flex">
            <Box mx={2}>
              <Button
                variant="contained"
                className={classes.stopService}
                onClick={() => handleChangeStatusService(false)}
                disabled={organization && organization.stoppedNotificationsService}
              >
                {config && config.stoppedNotificationsService ? <PlayArrow /> : <Pause />}
                Recordatorios GLOBAL (
                {config && config.stoppedNotificationsService ? 'pausado' : 'activo'})
              </Button>
            </Box>
            <Button
              variant="contained"
              className={classes.stopService}
              onClick={() => handleChangeStatusService(true)}
              disabled={config && config.stoppedNotificationsService}
            >
              {organization && organization.stoppedNotificationsService ? <PlayArrow /> : <Pause />}
              Recordatorios LOCAL (
              {organization && organization.stoppedNotificationsService ? 'pausado' : 'activo'})
            </Button>
          </Box>
          <Box my={2}>
            <Divider />
          </Box>
          <Typography className={classes.sectionTitle}>Clientes</Typography>
          <Box py={2} display="flex">
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                setActualItem({});
                setCreate(!create);
              }}
            >
              Agregar
            </Button>
          </Box>
          {create && (
            <Organization
              organization={{
                businessRules: {
                  fromThisDayOn: 1,
                  maxAppsOnGrid: 30,
                  maxAppsPerDay: 2,
                  sendImages: true,
                  receivesImages: true,
                  receivesAudio: true,
                },
              }}
              mode="create"
              actualItem={actualItem}
              handleShow={handleShow}
              handleEdit={handleEdit}
              handleSubmit={handleSubmit}
              organizationNames={organizations.map((e) => toUpper(e.name))}
            />
          )}
          {organizations.map((organization) => {
            return (
              <Organization
                key={organization.id}
                mode="update"
                organization={organization}
                actualItem={actualItem}
                credentials={(credentials && credentials[organization.id]) || ''}
                handleShow={handleShow}
                handleEdit={handleEdit}
                handleSubmit={handleSubmit}
                organizationNames={organizations.map((e) => toUpper(e.name))}
                generateCredentials={generateCredentials}
              />
            );
          })}
        </Container>
      </Box>
    </div>
  );
}
